module.exports = __webpack_public_path__ + "static/media/lines_footer.d74aff50.svg";